// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavMenu-module__nav--3QF_z","list":"NavMenu-module__list--ym4Q4","item":"NavMenu-module__item--KFeuM"};